import { render, staticRenderFns } from "./FormUserSupport.vue?vue&type=template&id=81616cce&scoped=true"
import script from "./FormUserSupport.vue?vue&type=script&lang=js"
export * from "./FormUserSupport.vue?vue&type=script&lang=js"
import style0 from "./FormUserSupport.vue?vue&type=style&index=0&id=81616cce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81616cce",
  null
  
)

export default component.exports